<template>
	<span :style="cssProps">
		<img class="logo" v-if="name && name.startsWith('http')" :src="name" />
		<span v-else class="logo">{{ name }}</span>
	</span>
</template>

<script>
	import store from "../store";

	export default {
		name: "logo",
		data() {
			return {
				name: "https://1e64.net/smartmydata-website-073be1/uploads/Capture-d-ecran--34--M2xp.png",
				menu_title_color: "#FFFFFF",
				menu_title_font: "sans",
				menu_title_size: 1,
			};
		},
		computed: {
			cssProps() {
				let css = {
					"--menu_title_color": this.menu_title_color,
					"--menu_title_font": this.menu_title_font,
					"--menu_title_size": this.menu_title_size + "em",
				};
				return css;
			},
		},
		methods: {
			setValuesFromState(stateObj) {
				if (typeof stateObj.style.name === "string") {
					this.name = stateObj.style.name;
				} else {
					this.name = stateObj.style.name.menu_title;
					this.menu_title_color =
						stateObj.style.name.menu_title_color;
					this.menu_title_font = stateObj.style.name.menu_title_font;
					this.menu_title_size = stateObj.style.name.menu_title_size;
				}
			},
		},
		mounted: async function () {
			var self = this;

			this.setValuesFromState(store.state);

			this.unsubscribe = this.$store.subscribe((mutation, state) => {
				if (
					mutation.type === "setStyle" ||
					mutation.type === "removeStyle"
				) {
					self.setValuesFromState(state);
				}
			});
		},
		beforeDestroy() {
			this.unsubscribe();
		},
	};
</script>

<style scoped>
	.logo {
		color: var(--menu_title_color);
		font-size: var(--menu_title_size);
		font-family: var(--menu_title_font) !important;
		/* color: hsla(0,0%,100%,.7); */
		padding: 10px;
		font-weight: 600;
		margin-left: auto;
		margin-right: auto;
		max-width: 100%;
		max-height: 100%;
		display: block;
	}
</style>
